export default __webpack_public_path__ + "static/media/espanha-flag.7c1e4dc2.svg";